import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCarts";

replaceInChain(chain, PopulateApiParameter, props => {
    props.apiParameter = {
        ...props.parameter.apiParameter,
        additionalQueryStringParameters: {
            isSpire: true,
        },
    };
});
